// eslint-disable-next-line import/prefer-default-export
export const toPascalCase = (text: string): string => {
  const textFiltered = text.replace('_', ' ');
  const words = textFiltered.trim() ? textFiltered.trim().split(' ') : []; // trim and check to handle empty string.
  const pascalCaseTextArray = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  );
  return pascalCaseTextArray.join(' ');
};
